import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import './set-public-path';
import Component from './GrowthChart';
import { mwcComponentName } from '../package.json';

export default function init() {
  if (!Vue.customElement) {
    Vue.use(VueCustomElement);
  }

  if (Vue.config.ignoredElements) {
    Vue.config.ignoredElements.push(mwcComponentName);
  }

  return Vue.customElement(mwcComponentName, Component);
}
